import Box from '@mui/material/Box'
import BHIcon from '../../atoms/icon'
import { useTheme } from '@mui/system'
import { elementType, shape, string } from 'prop-types'

const getDefaultSizes = (size) => {
	let boxSize = 76
	let iconSize = 23

	switch (size) {
		case 'xxl':
			boxSize = 142
			iconSize = 40
			break
		case 'lg':
			boxSize = 106
			iconSize = 32
			break
		case 'md':
			boxSize = 76
			iconSize = 23
			break
		case 'sm':
			boxSize = 46
			iconSize = 23
			break
	}

	return { boxSize: [boxSize, boxSize - 10, boxSize - 16], iconSize }
}

const IconBadge = ({ Icon, iconProps, size, boxStyle }) => {
	const theme = useTheme()

	const {
		boxSize: [box1Size, box2Size, box3Size],
		iconSize,
	} = getDefaultSizes(size)

	return (
		<Box
			borderRadius={'50%'}
			width={box1Size}
			height={box1Size}
			bgcolor={theme.palette.grey.lighter}
			margin="auto"
			display="flex"
			mb="37px"
			{...boxStyle}
		>
			<Box
				borderRadius={'50%'}
				width={box2Size}
				height={box2Size}
				bgcolor={theme.palette.common.white}
				margin="auto"
				display="flex"
			>
				<Box
					borderRadius={'50%'}
					width={box3Size}
					height={box3Size}
					bgcolor={theme.palette.grey.lighter}
					margin="auto"
					display="flex"
					alignItems="center"
					justifyContent="center"
				>
					<Icon sx={{ fontSize: iconSize }} color="secondary" {...iconProps} />
				</Box>
			</Box>
		</Box>
	)
}

IconBadge.defaultProps = {
	size: 'md',
	Icon: BHIcon,
}

IconBadge.propTypes = {
	Icon: elementType.isRequired,
	iconProps: shape(BHIcon.propTypes),
	size: string,
}

export default IconBadge
